import * as React from 'react';
type IconDropDownArrowProps = React.SVGProps<SVGSVGElement>;

export const IconDropDownArrow: React.FC<IconDropDownArrowProps> = (props) => (
	<svg
		width={25}
		height={24}
		viewBox="0 0 25 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}>
		<mask
			id="mask0_5865_2437"
			maskUnits="userSpaceOnUse"
			x="7"
			y="10"
			width="11"
			height="5">
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M7.66669 10L12.6667 15L17.6667 10H7.66669Z"
				fill="white"
			/>
		</mask>
		<g mask="url(#mask0_5865_2437)">
			<rect
				x="-12.3333"
				y="-13"
				width="50"
				height="50"
				fill="#ECEEEF"
			/>
			<mask
				id="mask1_5865_2437"
				maskUnits="userSpaceOnUse"
				x="-13"
				y="-13"
				width="51"
				height="50">
				<rect
					x="-12.3333"
					y="-13"
					width="50"
					height="50"
					fill="white"
				/>
			</mask>
			<g mask="url(#mask1_5865_2437)"></g>
		</g>
	</svg>
);
export default IconDropDownArrow;
